import { type ReactNode } from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/v2/tooltips/tooltip-container";
import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  icon?: ReactNode;
}

const TouchpointsCellFormatter = <
  TData extends { adsetName?: string; adName?: string; kind?: string },
>(
  props: TableCellProps<TData>,
) => {
  const row = props.cell.row.original;
  const adsetName = row?.adsetName;
  const adName = row?.adName;
  const showSubtext =
    adsetName && adName && adsetName !== "(no name)" && adName !== "(no name)";
  const isNotReferral = row?.kind !== "referer";

  return (
    <div
      className={clsx(
        "font-medium text-xs px-4 py-2.5 h-full bg-inherit text-v2-primary",
        "border-r border-v2-tertiary flex gap-2",
      )}
    >
      <div className="mr-1 h-6">{props.icon}</div>
      {showSubtext &&
        isNotReferral &&
        props.cell.column.id === "campaignName" && (
          <div>
            <div className="h-6 flex items-center font-semibold">Campaign:</div>
            <div className="h-6 flex items-center font-semibold justify-end text-v2-secondary">
              Adset:
            </div>
            <div className="h-6 flex items-center font-semibold justify-end text-v2-secondary">
              Ad:
            </div>
          </div>
        )}
      <div className="flex flex-col overflow-hidden">
        <div className="h-6 flex items-center">
          <GenericTooltip
            className="truncate"
            content={String(props.cell.getValue() || "--")}
            noInfoCircle
            placement="top"
          >
            {String(props.cell.getValue() || "--")}
          </GenericTooltip>
        </div>
        {showSubtext &&
          isNotReferral &&
          props.cell.column.id === "campaignName" && (
            <>
              <div className="h-6 flex items-center text-v2-secondary">
                <GenericTooltip
                  className="truncate"
                  content={adsetName}
                  noInfoCircle
                  placement="top"
                >
                  {adsetName}
                </GenericTooltip>
              </div>
              <div className="h-6 flex items-center text-v2-secondary">
                <GenericTooltip
                  className="truncate"
                  content={adName}
                  noInfoCircle
                  placement="top"
                >
                  {adName}
                </GenericTooltip>
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default TouchpointsCellFormatter;
